<import-file
  [title]="'Import Dealer Location'"
  [isGeneric]="false"
  [documentType]="documentType.Seller"
  [attachmentId]="attachmentId"
>
</import-file>
